// Frans (fr-FR), reminders: zelfde vorm als reminders.nl.ts. Tu-vorm, kort, voor kinderen.
export const kioskRemindersFr = {
    ok: 'OK !',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'OK',
    speak: '{names}, {title} !',
    context: '{title} à {time}',
    hint: 'Bientôt : {title} · {time}',
    and: 'et',
    dialog: 'Rappel : {title}',
    okFor: 'OK, {name}',
    checklist: 'Dans le sac',
    checklistLeft: 'encore {count}',
    checklistDone: 'Tout y est !',
    checklistDoneCalm: 'Tout est dans le sac',
    checklistItem: '{label}, {name}',
    checklistItemDone: '{label} est dans le sac',
    taskContext: 'Tâche à {time}',
};
//# sourceMappingURL=reminders.fr.js.map